import {
  CellClassParams,
  ProcessCellForExportParams,
  ProcessRowGroupForExportParams,
  ValueGetterParams,
} from '@ag-grid-community/core';
import { ICellClassesParams } from './TableExportFormatting';

type TotalCellParams =
  | CellClassParams
  | ICellClassesParams
  | ValueGetterParams
  | ProcessCellForExportParams
  | ProcessRowGroupForExportParams;

export const isTotalCell = (params: TotalCellParams) => {
  return params.node?.isRowPinned();
};

export const isSubtotalCell = (params: TotalCellParams) => {
  const isRootLevel = params.node?.level === -1;
  return Boolean(!isRootLevel && params.node?.footer);
};

export const isNormalCell = (params: TotalCellParams) => {
  return !isTotalCell(params) && !isSubtotalCell(params);
};
